import axios from 'axios'

export default {
    install(Vue, options) {
        var el = document.createElement('div');
        el.className = 'play_loading_wrap';
        el.innerHTML = '<span id="play_loading"></span>';

        Vue.prototype.$http = {
            before() {
                return axios.interceptors.request;
            },
            after() {
                return axios.interceptors.response;
            },
            cancelToken() {
                const CancelToken = axios.CancelToken;
                return CancelToken.source();
            },
            get(url, params, is_loading) {
                if(is_loading != false) {
                    document.body.appendChild(el);
                }

                return new Promise(function(resolve, reject) {
                    axios.get(url, params).then((response) => {
                        if(document.body.getElementsByClassName('play_loading_wrap').length > 0) {
                            document.body.removeChild(el);
                        }
                        resolve(response);
                    }).catch(error => {
                        if(document.body.getElementsByClassName('play_loading_wrap').length > 0) {
                            document.body.removeChild(el);
                        }
                        reject(error);
                        console.log(error);
                    });
                });
            },
            post(url, params, options, is_loading) {
                if(is_loading != false) {
                    document.body.appendChild(el);
                }

                return new Promise(function(resolve, reject) {
                    axios.post(url, params, options).then((response) => {
                        if(document.body.getElementsByClassName('play_loading_wrap').length > 0) {
                            document.body.removeChild(el);
                        }
                        resolve(response);
                    }).catch(error => {
                        if(document.body.getElementsByClassName('play_loading_wrap').length > 0) {
                            document.body.removeChild(el);
                        }
                        reject(error);
                        console.log(error);
                    });
                });
            },
            delete(url, params, is_loading) {
                if(is_loading != false) {
                    document.body.appendChild(el);
                }

                return new Promise(function(resolve, reject) {
                    axios.delete(url, params).then((response) => {
                        if(document.body.getElementsByClassName('play_loading_wrap').length > 0) {
                            document.body.removeChild(el);
                        }
                        resolve(response);
                    }).catch(error => {
                        if(document.body.getElementsByClassName('play_loading_wrap').length > 0) {
                            document.body.removeChild(el);
                        }
                        reject(error);
                        console.log(error);
                    });
                });
            }
        }        
    }    
}


// WEBPACK FOOTER //
// ./src/plugins/Http.js